module.exports = __webpack_public_path__ + "static/media/HRDashboard.52ff4255.PNG";